import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';

const STORAGE_KEY = 'cookie_consent';

const CookieBanner = () => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem(STORAGE_KEY)) {
            setVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem(STORAGE_KEY, 'accepted');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <Box sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            backgroundColor: '#0f2d5e',
            borderTop: '1px solid rgba(255,255,255,0.1)',
            px: { xs: 2, sm: 4 },
            py: 2,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'flex-start', sm: 'center' },
            gap: 2,
        }}>
            <Typography sx={{
                flex: 1,
                fontFamily: '"Outfit", sans-serif',
                fontSize: '0.85rem',
                color: 'rgba(255,255,255,0.85)',
                lineHeight: 1.5,
            }}>
                {t('cookie.message')}{' '}
                <Link href="/privacy" underline="hover" sx={{ color: '#F59E0B', fontWeight: 600 }}>
                    {t('cookie.privacy_link')}
                </Link>
                {'.'}
            </Typography>
            <Button
                variant="contained"
                disableElevation
                onClick={handleAccept}
                sx={{
                    fontFamily: '"Outfit", sans-serif',
                    fontWeight: 700,
                    fontSize: '0.85rem',
                    backgroundColor: '#F59E0B',
                    color: '#0f2d5e',
                    borderRadius: '8px',
                    px: 3,
                    py: 0.75,
                    whiteSpace: 'nowrap',
                    flexShrink: 0,
                    '&:hover': { backgroundColor: '#D97706' },
                }}
            >
                {t('cookie.accept')}
            </Button>
        </Box>
    );
};

export default CookieBanner;
